module.exports = __webpack_public_path__ + "img/highlight_off.fb60e6dd.svg";